import React from "react";
import { Globe } from "lucide-react";
import SiteReviews from "./SiteReviews";

export default function SiteView({ token, readOnly }) {
  return (
    <div className="space-y-8" data-testid="sa-site">
      <div>
        <h2 className="flex items-center gap-2 font-display text-xl font-bold text-white"><Globe className="h-5 w-5 text-[#FF6A00]" />Site vitrine</h2>
        <p className="mt-1 text-sm text-zinc-500">Contenu affiché sur halgaros.com (mise à jour sous 5 min). Les forfaits, le tableau comparatif, les options et les mentions se gèrent dans <strong className="text-zinc-300">Offres › Catalogue commercial</strong>.</p>
      </div>
      <SiteReviews token={token} readOnly={readOnly} />
    </div>
  );
}
